import {
  Sheet as ShadSheet,
  SheetContent as ShadSheetContent,
  SheetHeader as ShadSheetHeader,
  SheetTitle as ShadSheetTitle,
} from "@/components/ui/sheet"
import Button from "@/components/button"
import Bottombar from "@/components/bottombar"
import { DialogDescription } from "@/components/ui/dialog"
import useStore from "@/store"
import SpinnerCircle from "@/components/spinner"

export type PendingSubmissionSheetProps = {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onClickBack?: () => void
  onEndShift?: () => void
}

export default function PendingSubmissionSheet({
  open,
  onOpenChange,
  onClickBack,
  onEndShift,
}: PendingSubmissionSheetProps) {
  const { submissions } = useStore.use.packaging()

  return (
    <ShadSheet open={open} onOpenChange={onOpenChange}>
      <ShadSheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto rounded-t-lg"
      >
        <ShadSheetHeader>
          <ShadSheetTitle className="text-xl font-semibold flex flex-col gap-5">
            Submitting Sheets
          </ShadSheetTitle>
        </ShadSheetHeader>

        <DialogDescription className="px-4 pb-4 sr-only">
          Submitting pending sheets
        </DialogDescription>

        <div className="flex flex-col gap-2 shadow-xs px-4 pb-4">
          {submissions.map((submission, index) => (
            <div
              key={submission.sectionId + submission.productId}
              className="border border-input-border rounded-sm p-2 font-medium flex justify-between items-center"
            >
              <div>
                <div className="text-sm">
                  {submission.productName} • {submission.sectionName}
                </div>
                <div className="text-xs text-label-text">
                  {submission.deptName} • {submission.machineName}
                </div>
              </div>

              {index === 0 && (
                <SpinnerCircle variant="light" className="size-6" />
              )}
            </div>
          ))}

          {!submissions.length && (
            <div className="flex justify-center text-label-text py-10">
              No submissions left
            </div>
          )}
        </div>

        <Bottombar className="bg-white">
          {submissions.length ? (
            <Button className="w-full" onClick={onClickBack}>
              Go Back
            </Button>
          ) : (
            <Button className="w-full" onClick={onEndShift}>
              End Process
            </Button>
          )}
        </Bottombar>
      </ShadSheetContent>
    </ShadSheet>
  )
}
